import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { AccommodationCard } from '~/components/ItineraryCard/src/AccommodationCard';
import { HeroRouteCard } from '~/components/ItineraryCard/src/HeroRouteCard';
import { LegCard } from '~/components/ItineraryCard/src/LegCard';
import type { TripAccommodationStay } from '~/services/engine-ts';
import type { TripSection } from '~/stores/tpv2/journeyStore';
import { ITINERARY_ITEM_ID_PREFIX, useOverviewProgressStore } from '~/stores/tpv2/overviewProgressStore';
import type { AnyJourneyItemTransformed, LegTransformed, StayTransformed } from '~/types/JourneyItem.types';
import styles from './ItineraryItemCard.module.css';
type ItineraryItemCardProps = {
  item: AnyJourneyItemTransformed;
  section: TripSection;
  tripId: string;
  isReturnLeg?: boolean;
  accommodationStay?: TripAccommodationStay;
  dayNumber?: number;
};
const ITINERARY_ITEM_SCROLL_MARGIN_TOP = 120;
export function ItineraryItemCard(t0) {
  const $ = _c(16);
  const {
    item,
    section,
    tripId,
    isReturnLeg: t1,
    accommodationStay,
    dayNumber
  } = t0;
  const isReturnLeg = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== item.id) {
    t2 = s => s.activeItemId === String(item.id);
    $[0] = item.id;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const isActive = useOverviewProgressStore(t2);
  let t3;
  if ($[2] !== accommodationStay || $[3] !== dayNumber || $[4] !== isReturnLeg || $[5] !== item || $[6] !== section || $[7] !== tripId) {
    const renderCard = () => {
      switch (item.type) {
        case "Journey":
          {
            const leg = item as LegTransformed;
            if (leg.heroRouteCmsId != null && !isReturnLeg) {
              return <HeroRouteCard {...leg} section={section} />;
            }
            return <LegCard {...leg} section={section} dayNumber={dayNumber} />;
          }
        case "Stay":
          {
            return <AccommodationCard {...item as StayTransformed} section={section} tripId={tripId} accommodationStay={accommodationStay} accommodationVariant={section === "accommodation" ? "stay-expanded" : undefined} />;
          }
        case "Stop":
          {
            return null;
          }
        default:
          {
            return null;
          }
      }
    };
    t3 = renderCard();
    $[2] = accommodationStay;
    $[3] = dayNumber;
    $[4] = isReturnLeg;
    $[5] = item;
    $[6] = section;
    $[7] = tripId;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const card = t3;
  if (!card) {
    return null;
  }
  const t4 = `${ITINERARY_ITEM_ID_PREFIX}${item.id}`;
  const t5 = isActive && styles.itemActive;
  let t6;
  if ($[9] !== t5) {
    t6 = clsx(styles.item, t5);
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      scrollMarginTop: ITINERARY_ITEM_SCROLL_MARGIN_TOP
    };
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== card || $[13] !== t4 || $[14] !== t6) {
    t8 = <div id={t4} className={t6} style={t7}>{card}</div>;
    $[12] = card;
    $[13] = t4;
    $[14] = t6;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}